<template>
  <el-dialog
    title="资讯详情"
    :visible="true"
    width="1400px"
    :before-close="() => handleClose(false)"
    class="public-preview-dialog"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    append-to-body
  >
    <el-row type="flex" class="content-module top-module">
      <div class="content-left">
        <img :src="publicDetail.img" alt="宣传图" class="img">
        <p class="img-sub-title" v-html="publicDetail.title" />
      </div>
      <div class="content-right">
        <p class="content-title">军转培训介绍</p>
        <p class="content-text" v-html="publicDetail.content" />
      </div>
    </el-row>
  </el-dialog>
</template>
<script>
export default {
  name: 'InformationPreview',
  props: ['handleClose', 'viewData'],
  data() {
    return {
      publicDetail: this.viewData
    }
  }
}
</script>
<style lang="scss" scoped>
.public-preview-dialog {
  ::v-deep .el-dialog {
    min-height: auto;
  .el-dialog__body {
     min-height: auto;
   }
  }
}
.top-module {
  .content-left {
    width: 836px;
    height: 504px;
    position: relative;
    .img {
      width: 100%;
      height: 458px;
    }
    .img-sub-title {
      width: 836px;
      height: 46px;
      position: absolute;
      bottom: 0;
      left: 0;
      background-color: #0861D5;
      line-height: 46px;
      text-align: center;
      font-size: 16px;
      color: #FFFFFF;
      overflow: hidden;
    }
  }
  .content-right {
    flex: 1;
    height: 504px;
    box-sizing: border-box;
    padding: 32px;
    background: linear-gradient( 180deg, #DFEDFF 0%, #FFFFFF 100%, #FFFFFF 100%);
    .content-title {
      margin-bottom: 8px;
      position: relative;
      line-height: 28px;
      font-weight: 600;
      font-size: 20px;
      color: #2F2F2F;
      &::after {
        display: block;
        content: '';
        width: 100%;
        height: 4px;
        background: linear-gradient( 90deg, rgba(255,255,255,0) 0%, #0861D5 48%, rgba(255,255,255,0) 100%), #0861D5;
        position: absolute;
        left: 0;
        bottom: -8px;
      }
    }
    .content-text {
      max-height: 446px;
      overflow-y: auto;
      padding-top: 24px;
      line-height: 32px;
      font-size: 16px;
      color: #2F2F2F;
    }
  }
}
</style>
